export const defaultLang = "it";
export const supportedLangs = {
  it: "Italiano",
  en: "English",
};
